// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vx_a bhe_b bhe_wb"};